(function(){
    angular
        .module('app')
        .directive('ngSelect2', select2);

        select2.$inject = ['$timeout'];
        function select2($timeout){
            return {
              require: 'ngModel',
              scope:{
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	scope.$watch(function () {
		              return ngModel.$modelValue;
		              //console.log("change valu2e");
		            }, function(newValue) {
		            	$timeout(function(){
		            		//console.log("change value");
                       		element.trigger('change.select2');
		            	})
		            });
                });
            }
          }
      }
})();